import(/* webpackMode: "eager" */ "/srv/apps/admin/app/global-error.tsx");
